<template>
  <div class="head" :class="{'offline-model':$initIsOffline}">
    <div class="header">
      <div class="header-content">
        <div style="display:flex;align-items:center;">
          <h3 style="margin:0;">
            {{$initIsOffline?'离线模式':'在线模式'}}(1.3.0)&nbsp;
            <i style="cursor: pointer;" class="el-icon-thumb" @click="()=>showLogDialog=true"></i>
          </h3>
          <div style="min-width:100px;margin-left:20px;" v-if="storageObj.show">
            {{ diskUsageFormat() }}
          </div>
        </div>
        <div>
          <div class="logo" />
        </div>
        <div>
          <div class="tab">
            <div style="margin-right:20px;" @click="()=>toggleScreen()">
              <i style="cursor:pointer;font-size:24px; font-weight:bold;" class="jodoll-tailor" :class="{'tailor-quanpingzhanshi':!isScreenfull,'tailor-tuichuquanping':isScreenfull}"></i>
            </div>
            <div class="home" @click="goHome"/>
            <div class="user-photo" @click="personalCenter">
              <el-avatar :size="40" :src="userInfo.img?userInfo.img:(userInfo.sex?avatarNan:avatarNv)"/>
            </div>
            <div class="user-name" @click="personalCenter">
              {{ userInfo.realname }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <router-view />
    </div>
    <logDialog v-if="showLogDialog" :show.sync="showLogDialog"/>
  </div>
</template>

<script>
import screenfullMixin from '@/mixins/screenfullMixin';
import { getUserInfo } from '@/utils/auth';
import avatarNan from '@/assets/User_b@2x.png'
import avatarNv from '@/assets/User_g@2x.png'
import logDialog from '@/components/logDialog.vue';
export default {
  components:{logDialog},
  mixins:[screenfullMixin],
  data() {
    return {
      showLogDialog:false,
      avatarNan,
      avatarNv,
      userInfo:{},
      storageObj:{
        show:false,
        total:0,
        usage:0,
        usageProportion:0,
      },
    }
  },
  created() {
    if ('storage' in navigator && 'estimate' in navigator.storage) {
      navigator.storage.estimate().then(estimate => {
        let {quota,usage}=estimate;
        let total =parseFloat((quota / (1024 ** 3)).toFixed(2));
        let used = parseFloat((usage / (1024 ** 3)).toFixed(2));
        let usageProportion =parseFloat((usage / quota * 100).toFixed(2));
        this.storageObj={
          show:true,total,usage:used,usageProportion
        };
      });
    }
    this.userInfo=JSON.parse(getUserInfo());
  },
  methods: {
    diskUsageFormat(){
      let {total,usage,usageProportion}=this.storageObj;
      return `${usageProportion}%（${usage}/${total}）`;
    },
    goHome() {
      this.$router.push('/measure/measureIndex')
    },
    personalCenter() {
      this.$router.push({name: 'personalCenter'})
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  box-shadow: 0px 2px 4px 0px rgba(203,203,203,0.5);
  margin-bottom: 5px;
  .header-content{
    display:flex;justify-content: space-between;align-items: center;
    padding:8px 20px;
  }
}
.offline-model{
  background-color:rgba(0,0,0,0.05) ;
  box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.logo {
  width: 80px;
  height: 33px;
  background-image: url("@/assets/login/icon_logo.png");
  background-size: cover;
}
.tab {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: end;
}
.tab .home {
  width: 26px;
  height: 26px;
  cursor: pointer;
  background-image: url('@/assets/index/icon_home.png');
  background-size: cover;
}

.user-photo {
  width: 40px;
  height: 40px;
  margin-right: 0.6vw;
  margin-left: 1vw;
  cursor: pointer;
}
.user-photo img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.container {
  background: #FFFFFF;
  height: calc( 100vh - 8vh - 5px);
}

.user-name{
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  cursor: pointer;
}
</style>